import React from 'react';
import { Card, CardContent } from './ui/card';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import { getImageUrl } from '../lib/imageUtils';

const PRODUCT_FALLBACK_IMAGES = {
  'Astral Pipes': 'https://images.unsplash.com/photo-1649706286480-1c6f3f3c1fb1?w=800',
  'Zoloto Valves': 'https://images.unsplash.com/photo-1698031610493-c19fa20dfeab?w=800',
};

const Products = ({ products = [] }) => {
  if (!products || products.length === 0) return null;

  return (
    <section id="products" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-3">Our Products</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Authorized Distributor Of <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">Premium Brands</span>
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-500 to-yellow-600 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {products.map((product, index) => (
            <Card key={index} className="overflow-hidden border-2 hover:border-blue-200 transition-all hover:shadow-2xl group" data-testid={`product-card-${index}`}>
              <div className={`h-3 bg-gradient-to-r ${
                product.color === 'blue' ? 'from-blue-500 to-blue-700' : 'from-yellow-500 to-yellow-700'
              }`}></div>
              <CardContent className="p-8">
                <div className="mb-6">
                  <div className="w-full h-48 bg-white rounded-xl shadow-md overflow-hidden border-2 border-gray-100">
                    <img 
                      src={getImageUrl(product.image_url, PRODUCT_FALLBACK_IMAGES[product.name] || 'https://images.unsplash.com/photo-1649706286480-1c6f3f3c1fb1?w=800')} 
                      alt={product.name} 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>

                <h4 className="text-3xl font-bold text-gray-900 mb-4">{product.name}</h4>
                <p className="text-gray-600 leading-relaxed mb-6">{product.description}</p>

                <div className="mb-6">
                  <h5 className="text-lg font-semibold text-gray-900 mb-3">Product Range:</h5>
                  <div className="grid grid-cols-1 gap-2">
                    {(product.features || []).map((feature, idx) => (
                      <div key={idx} className="flex items-start space-x-2">
                        <CheckCircle2 className={`${
                          product.color === 'blue' ? 'text-blue-600' : 'text-yellow-600'
                        } flex-shrink-0 mt-0.5`} size={18} />
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-6">
                  <h5 className="text-lg font-semibold text-gray-900 mb-3">Applications:</h5>
                  <div className="flex flex-wrap gap-2">
                    {(product.applications || []).map((app, idx) => (
                      <span 
                        key={idx} 
                        className={`px-3 py-1 rounded-full text-sm font-medium ${
                          product.color === 'blue' 
                            ? 'bg-blue-100 text-blue-700' 
                            : 'bg-yellow-100 text-yellow-700'
                        }`}
                      >
                        {app}
                      </span>
                    ))}
                  </div>
                </div>

                <Button 
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className={`w-full bg-gradient-to-r ${
                    product.color === 'blue' 
                      ? 'from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900' 
                      : 'from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800'
                  } text-white`}
                  data-testid={`product-cta-${index}`}
                >
                  Request Quote for {product.name}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
